import { SDK_Filter } from "../gql/generated/operations.js";

export function checkSizesAreNumbers(
  filter: SDK_Filter,
): SDK_Filter {
  if (!filter) return filter;
  // list of filter modifiers should be numbers
  const modifiersToCheck = [
    "border",
    "cornerRadius",
    "fontSize",
    "gap",
    "height",
    "lineHeight",
    "lineHeightMultiplier",
    "opacity",
    "paddingBlockEnd",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlockStart",
    "space",
  ] as const;

  for (const key of Object.keys(filter)) {
    // @ts-ignore
    if (modifiersToCheck.includes(key) && typeof filter[key] !== "number") {
      // @ts-ignore
      filter[key] = filter[key] ? parseFloat(filter[key]) : 0;
    }
    // @ts-ignore
    if (typeof filter[key] === "object") {
      // @ts-ignore
      checkSizesAreNumbers(filter[key]);
    }
  }

  return filter;
}
